<template lang="pug">
  .flow-builder-go-to-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 Ir a bloque
        p.text-secondary.text-sm Conecta con otro bloque
      template-connector(v-for="(connector, connector_index) in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import Connector from '@/components/templates/connectors/Connector.vue'
import templateCommon from '@/helpers/template-common'
import TemplateTools from '@/components/templates/common/Tools.vue'

export default {
  mixins: [templateCommon],
  components: {
    'template-connector': Connector,
    TemplateTools
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-go-to-template {
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
    position: relative;
  }
</style>
